module.exports = __webpack_public_path__ + "img/202410_01.ebc7f895.jpg";